"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _rtlCssJs = _interopRequireDefault(require("rtl-css-js"));

var _object = _interopRequireDefault(require("object.entries"));

var _resolveLTR2 = _interopRequireDefault(require("./utils/resolveLTR"));

var _resolveRTL2 = _interopRequireDefault(require("./utils/resolveRTL"));

var _default = function _default(_ref
/* aphrodite */
) {
  var StyleSheet = _ref.StyleSheet,
      css = _ref.css,
      flushToStyleTag = _ref.flushToStyleTag;
  return {
    create: function create(styleHash) {
      return StyleSheet.create(styleHash);
    },
    createLTR: function createLTR(styleHash) {
      return StyleSheet.create(styleHash);
    },
    createRTL: function createRTL(styleHash) {
      var styleHashRTL = {};
      (0, _object["default"])(styleHash).forEach(function (_ref2) {
        var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
            styleKey = _ref3[0],
            styleDef = _ref3[1];

        styleHashRTL[styleKey] = (0, _rtlCssJs["default"])(styleDef);
      });
      return StyleSheet.create(styleHashRTL);
    },
    resolve: function resolve(styles) {
      return (0, _resolveLTR2["default"])(css, styles);
    },
    resolveLTR: function resolveLTR(styles) {
      return (0, _resolveLTR2["default"])(css, styles);
    },
    resolveRTL: function resolveRTL(styles) {
      return (0, _resolveRTL2["default"])(css, styles);
    },
    // Flushes all buffered styles to a style tag. Required for components
    // that depend upon previous styles in the component tree (i.e.
    // for calculating container width, including padding/margin).
    flush: function flush() {
      flushToStyleTag();
    }
  };
};

exports["default"] = _default;